import React from 'react'
import { toAbsoluteUrl } from '../../../_metronic/_helpers'

export const OrderPDF = ({ pdfRef, download, setDownload, user }) => {
  return (
    <div style={{ visibility: 'hidden' }}>
      <div id="order_pdf_page" ref={pdfRef}>
        <center>
          <table
            cellSpacing="0"
            cellPadding="0"
            border="0"
            style={{
              fontFamily: 'Product Sans',
              margin: '0 auto',
              width: '600px',
            }}
          >
            <tbody>
              <tr>
                <td
                  style={{
                    padding: '20px',
                    background: '#3E4AB8',
                    verticalAlign: 'middle',
                  }}
                  align="center"
                >
                  <img
                    src={toAbsoluteUrl("/media/logos/logo-light.svg")}
                    alt="logo"
                  />
                </td>
              </tr>
              <tr>
                <td
                  colspan="2"
                  style={{
                    fontSize: '24px',
                    color: '#212121',
                    lineHeight: '32px',
                    padding: '10px 10px 0',
                  }}
                >
                  Hello, {user.firstName + ' ' + user.lastName}
                </td>
              </tr>
              <tr>
                <td
                  colspan="2"
                  style={{
                    fontSize: '20px',
                    color: '#727171',
                    lineHeight: '32px',
                    padding: '0 10px 0',
                  }}
                >
                  Your order Details!
                </td>
              </tr>
              {/* <tr>
                    <td colspan="2" style="font-size: 20px; color: #727171;line-height: 32px;padding: 10px 0;">
                        <img src="./complate.png" alt="complated" style="display: table;margin: 0 auto;" />
                    </td>
                </tr> */}
              <tr>
                <td colSpan="2">
                  <table
                    cellPadding="0"
                    style={{
                      fontFamily: 'Product Sans',
                      margin: '0 auto',
                      width: '600px',
                    }}
                  >
                    <tbody>
                      <tr>
                        <td
                          style={{
                            fontSize: '16px',
                            color: '#212121',
                            lineHeight: '32px',
                            padding: '10px',
                            background: '#fafafc',
                            width: '50%',
                          }}
                        >
                          Date and Time
                        </td>
                        <td
                          style={{
                            fontSize: '16px',
                            color: '#3E4AB8',
                            fontWeight: '500',
                            lineHeight: '32px',
                            padding: '10px',
                            background: '#fafafc',
                          }}
                        >
                          {new Date(download.timeStamp).getDate()}&nbsp;
                          {new Date(
                            download.timeStamp,
                          ).toLocaleString('default', { month: 'short' })}
                          &nbsp;{new Date(download.timeStamp).getFullYear()}{' '}
                          &nbsp;|&nbsp;{' '}
                          {new Date(download.timeStamp).getHours()} :{' '}
                          {new Date(download.timeStamp).getMinutes()}
                        </td>
                      </tr>
                      <tr>
                        <td
                          style={{
                            fontSize: '16px',
                            color: '#212121',
                            lineHeight: '32px',
                            padding: '10px',
                            background: '#f2f2fa',
                            width: '50%',
                          }}
                        >
                          Status
                        </td>
                        <td
                          style={{
                            fontSize: '16px',
                            color: '#3E4AB8',
                            fontWeight: '500',
                            lineHeight: '32px',
                            padding: '10px',
                            background: '#f2f2fa',
                          }}
                        >
                          {download.status}
                        </td>
                      </tr>
                      <tr>
                        <td
                          style={{
                            fontSize: '16px',
                            color: '#212121',
                            lineHeight: '32px',
                            padding: '10px',
                            background: '#fafafc',
                            width: '50%',
                          }}
                        >
                          Equivalent Gold
                        </td>
                        <td
                          style={{
                            fontSize: '16px',
                            color: '#3E4AB8',
                            fontWeight: '500',
                            lineHeight: '32px',
                            padding: '10px',
                            background: '#fafafc',
                          }}
                        >
                          {download.units} GMS
                        </td>
                      </tr>
                      {/* <tr>
                        <td
                          style={{
                            fontSize: '16px',
                            color: '#212121',
                            lineHeight: '32px',
                            padding: '10px',
                            background: '#f2f2fa',
                            width: '50%',
                          }}
                        >
                          Payment By
                        </td>
                        <td
                          style={{
                            fontSize: '16px',
                            color: '#3E4AB8',
                            fontWeight: '500',
                            lineHeight: '32px',
                            padding: '10px',
                            background: '#f2f2fa',
                          }}
                        >
                          Card
                        </td>
                      </tr> */}
                      <tr>
                        <td
                          style={{
                            fontSize: '16px',
                            color: '#212121',
                            lineHeight: '32px',
                            padding: '10px',
                            background: '#fafafc',
                            width: '50%',
                          }}
                        >
                          Tokens
                        </td>
                        <td
                          style={{
                            fontSize: '16px',
                            color: '#3E4AB8',
                            fontWeight: '500',
                            lineHeight: '32px',
                            padding: '10px',
                            background: '#fafafc',
                          }}
                        >
                          {download.tokens} USD
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </td>
              </tr>
              <tr>
                <td
                  colspan="2"
                  style={{
                    fontSize: '20px',
                    color: '#727171',
                    lineHeight: '32px',
                    padding: '10px',
                  }}
                >
                  Thanks
                </td>
              </tr>
            </tbody>
          </table>
        </center>
      </div>
    </div>
  )
}
